import React, { useState, useEffect } from "react";
import {
    MdStar,
    MdPerson,
    MdContentCut,
    MdEvent,
    MdWarning,
    MdKeyboardArrowLeft,
    MdKeyboardArrowRight,
    MdRateReview
} from "react-icons/md";

import { appointmentsAPI } from "services/api";

// --- YILDIZ GÖSTERİM BİLEŞENİ ---
const StarRating = ({ rating }) => {
    return (
        <div className="flex items-center gap-1">
            {[1, 2, 3, 4, 5].map((star) => (
                <MdStar
                    key={star}
                    className={`text-xl md:text-2xl ${
                        star <= rating ? "text-amber-400 drop-shadow-sm" : "text-gray-200 dark:text-navy-700"
                    }`}
                />
            ))}
        </div>
    );
};

// --- SKELETON LOADER ---
const ReviewsSkeleton = () => (
    <div className="flex flex-col gap-4 animate-pulse">
        {[...Array(5)].map((_, i) => (
            <div key={i} className="flex flex-col p-6 rounded-[20px] bg-gray-100 dark:bg-navy-900/50">
                <div className="flex justify-between items-start mb-4">
                    <div className="flex flex-col gap-2 w-1/2">
                        <div className="h-5 w-3/4 bg-gray-200 dark:bg-navy-700 rounded" />
                        <div className="h-4 w-1/2 bg-gray-200 dark:bg-navy-700 rounded" />
                    </div>
                    <div className="h-6 w-24 bg-gray-200 dark:bg-navy-700 rounded-full" />
                </div>
                <div className="h-4 w-1/4 bg-gray-200 dark:bg-navy-700 rounded mb-4" />
                <div className="h-12 w-full bg-gray-200 dark:bg-navy-700 rounded-xl" />
            </div>
        ))}
    </div>
);

const CustomerReviews = () => {
    // --- STATE TANIMLAMALARI (WORK-LOGIC BİREBİR) ---
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Sayfalama (Pagination) Stateleri
    const [currentPage, setCurrentPage] = useState(1);
    const PAGE_SIZE = 10;

    // --- API VERİ ÇEKME (WORK-LOGIC BİREBİR) ---
    useEffect(() => {
        const fetchMyReviews = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await appointmentsAPI.getMyAppointments();

                if (response.success) {
                    const reviewedAppointments = response.appointments
                        .filter((appointment) => appointment.rating)
                        .map((appointment) => ({
                            id: appointment.rating.id,
                            appointmentId: appointment.id,
                            barberName: `${appointment.staff?.name || 'Silinmiş'} ${appointment.staff?.surname || 'Personel'}`,
                            service: appointment.service?.name || 'Silinmiş Hizmet',
                            rating: appointment.rating.rating,
                            comment: appointment.rating.comment || "",
                            date: appointment.appointment_date,
                            createdAt: appointment.rating.created_at,
                        }))
                        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

                    setReviews(reviewedAppointments);
                }
            } catch (err) {
                console.error("Error fetching reviews:", err);
                setError(err.message || "Değerlendirmeler yüklenirken bir hata oluştu");
            } finally {
                setLoading(false);
            }
        };

        fetchMyReviews();
    }, []);

    // --- SAYFALAMA HESAPLARI ---
    const totalPages = Math.max(1, Math.ceil(reviews.length / PAGE_SIZE));
    const currentReviews = reviews.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    // --- RENDER ---
    return (
        <div className="mt-5 flex w-full flex-col gap-6 pb-20 animate-fadeIn">

            {/* 1. ÜST BAŞLIK ALANI (GOLDEN GRADIENT EFEKTLİ) */}
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 bg-white p-6 rounded-[20px] shadow-3xl shadow-shadow-500 dark:bg-navy-800 dark:shadow-none border border-gray-100 dark:border-white/10">
                <div className="flex items-center gap-4 w-full md:w-auto">
                    {/* Lüks Golden Gradient İkon */}
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-yellow-400 to-orange-500 text-white shadow-lg shadow-orange-500/30 flex-none">
                        <MdRateReview className="text-3xl" />
                    </div>
                    <div>
                        <h4 className="text-xl font-bold text-navy-700 dark:text-white">Değerlendirmelerim</h4>
                        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Geçmiş hizmetleriniz için yaptığınız yorumlar ve verdiğiniz puanlar.
                        </p>
                    </div>
                </div>
            </div>

            {/* Hata Durumu */}
            {error && (
                <div className="p-4 rounded-xl bg-red-50 text-red-600 border border-red-200 dark:bg-red-500/10 dark:border-red-500/20 dark:text-red-400 text-sm font-bold flex items-center gap-2">
                    <MdWarning className="text-xl" /> {error}
                </div>
            )}

            {/* 2. DEĞERLENDİRME LİSTESİ */}
            <div className="flex flex-col bg-white dark:bg-navy-800 rounded-[20px] shadow-sm border border-gray-100 dark:border-white/10 overflow-hidden">

                {/* Kart Başlığı */}
                <div className="flex items-center justify-between p-6 border-b border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/20">
                    <h5 className="text-lg font-bold text-navy-700 dark:text-white">Yaptığım Değerlendirmeler</h5>
                    <span className="px-3 py-1 bg-brand-50 text-brand-500 dark:bg-brand-400/10 dark:text-brand-400 rounded-lg text-sm font-bold">
            {reviews.length} Toplam
          </span>
                </div>

                <div className="p-6">
                    {loading ? (
                        <ReviewsSkeleton />
                    ) : reviews.length === 0 ? (
                        // BOŞ DURUM (EMPTY STATE)
                        <div className="flex flex-col items-center justify-center py-16 opacity-60">
                            <MdStar className="text-7xl text-gray-300 dark:text-gray-600 mb-4" />
                            <h5 className="text-xl font-bold text-navy-700 dark:text-white mb-2">Henüz bir değerlendirme yapmadınız.</h5>
                            <p className="text-sm font-medium text-gray-500 text-center max-w-md">
                                Tamamlanan randevularınız için "Randevularım" sayfasından hizmet kalitemizi değerlendirebilirsiniz.
                            </p>
                        </div>
                    ) : (
                        // DEĞERLENDİRME KARTLARI
                        <div className="flex flex-col gap-4">
                            {currentReviews.map((review) => (
                                <div
                                    key={review.id}
                                    className="flex flex-col p-6 rounded-2xl bg-white dark:bg-navy-900 border border-gray-100 dark:border-white/5 shadow-sm hover:shadow-md transition-shadow duration-300"
                                >
                                    <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-4">

                                        {/* Personel ve Hizmet Bilgisi */}
                                        <div className="flex flex-col">
                                            <div className="flex items-center gap-2 mb-1">
                                                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-50 text-brand-500 dark:bg-brand-400/10 dark:text-brand-400">
                                                    <MdPerson className="text-lg" />
                                                </div>
                                                <h5 className="text-lg font-bold text-navy-700 dark:text-white">
                                                    {review.barberName}
                                                </h5>
                                            </div>

                                            <div className="flex items-center gap-2 ml-10">
                                                <MdContentCut className="text-gray-400 text-sm" />
                                                <span className="text-sm font-bold text-gray-500 dark:text-gray-400">
                          {review.service}
                        </span>
                                            </div>
                                        </div>

                                        {/* Tarih ve Yıldızlar */}
                                        <div className="flex flex-col md:items-end gap-2 ml-10 md:ml-0">
                                            <StarRating rating={review.rating} />
                                            <div className="flex items-center gap-1 text-xs font-bold text-gray-400 uppercase tracking-widest bg-gray-50 dark:bg-navy-800 px-2 py-1 rounded-md">
                                                <MdEvent />
                                                {new Date(review.date).toLocaleDateString("tr-TR", {
                                                    year: "numeric",
                                                    month: "long",
                                                    day: "numeric",
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Yorum (Comment) Alanı */}
                                    {review.comment && (
                                        <div className="relative mt-2 p-4 rounded-xl bg-gray-50 dark:bg-navy-800 border border-gray-100 dark:border-white/5">
                                            {/* Lüks Vurgu Çizgisi */}
                                            <div className="absolute left-0 top-0 bottom-0 w-1 bg-amber-400 rounded-l-xl" />
                                            <p className="text-sm font-medium text-gray-600 dark:text-gray-300 italic pl-2">
                                                "{review.comment}"
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* 3. SAYFALAMA (PAGINATION) */}
                {!loading && totalPages > 1 && (
                    <div className="flex flex-col sm:flex-row items-center justify-between p-6 border-t border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/20 gap-4">
            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">
              <span className="font-bold text-navy-700 dark:text-white">{reviews.length}</span> değerlendirmeden <span className="font-bold text-navy-700 dark:text-white">{(currentPage-1)*PAGE_SIZE + 1}-{Math.min(currentPage*PAGE_SIZE, reviews.length)}</span> gösteriliyor.
            </span>

                        <div className="flex items-center gap-2">
                            <button
                                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                                disabled={currentPage === 1}
                                className="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 disabled:opacity-40 hover:bg-gray-50 dark:border-white/10 dark:bg-navy-800 dark:hover:bg-navy-700 transition-all active:scale-95"
                            >
                                <MdKeyboardArrowLeft className="text-2xl" />
                            </button>

                            <div className="flex h-10 min-w-[40px] items-center justify-center rounded-xl bg-brand-500 text-white text-sm font-bold shadow-md px-3">
                                {currentPage}
                            </div>

                            <button
                                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                                disabled={currentPage === totalPages}
                                className="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 disabled:opacity-40 hover:bg-gray-50 dark:border-white/10 dark:bg-navy-800 dark:hover:bg-navy-700 transition-all active:scale-95"
                            >
                                <MdKeyboardArrowRight className="text-2xl" />
                            </button>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default CustomerReviews;